import Header from "components/Header";
import { BrowserRouter as Router } from "react-router-dom";
import { useEffect, useState } from "react";
import AppRoutes from "routes";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };
  useEffect(() => {
    document.addEventListener("mousemove", (e) => {
      let x = e.clientX;
      let y = e.clientY;
      document
        .getElementById("cursor-div")
        .setAttribute("style", "top: " + y + "px; left: " + x + "px;");
    });
  }, []);

  return (
    <>
      <div
        className={`bg-light dark:bg-dark min-h-screen relative ${
          !darkMode ? "app-container" : "dark-app-container"
        }`}
      >
        <div id='cursor-div' className='fixed top-0 left-0 z-1'>
          <div className='cursor relative top-0 left-0'></div>
        </div>
        <Router>
          <Header darkToggle={toggleDarkMode} darkMode={darkMode} />
          <AppRoutes />
        </Router>
      </div>
    </>
  );
}

export default App;
